import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

import { useSelector } from 'react-redux';

import LoginIcon from '../common/icons/LoginIcon';
import MenuIcon from '../common/icons/MenuIcon';

import { LogoWhite, LogoBlack } from '../common/icons/Logos';

import DesktopHeaderUserDropdown from './DesktopHeaderUserDropdown';

const TransparentHeader = props => {
  const { isAuthenticated } = useSelector(state => state);

  const isPrimary = props.isPrimary || false;

  const linkClassNames = classnames('desktop-menu-link', { 'is-secondary': !isPrimary });
  const iconClassNames = classnames('desktop-menu-icon', { 'is-secondary': !isPrimary });

  return (
    <nav className={classnames('desktop-menu', { 'is-secondary': !isPrimary })}>
      <div className="desktop-menu-container tutorium-container">
        <div className="is-flex align-items-center">
          <div className="desktop-menu-burger" onClick={props.openSidebar}>
            <MenuIcon className={iconClassNames} />
          </div>
          <Link to="/" className="is-flex">
            {isPrimary ? <LogoWhite /> : <LogoBlack />}
          </Link>
        </div>
        <div className="desktop-menu-links is-fullheight">
          <HashLink to="/#info-screen-container-id" className={linkClassNames} smooth>
            About
          </HashLink>
          <Link to="/courses" className={linkClassNames}>
            Courses
          </Link>
          <HashLink to="/#faq-screen-container-id" className={linkClassNames} smooth>
            FAQ
          </HashLink>
          <HashLink to="/#request-screen-container-id" className={linkClassNames} smooth>
            Contacts
          </HashLink>
        </div>
        <div className=" is-flex is-fullheight">
          {isAuthenticated && <DesktopHeaderUserDropdown iconClassNames={iconClassNames} />}
          {!isAuthenticated && (
            <Link to="/auth" className={linkClassNames}>
              <div className="is-flex align-items-center">
                <span className="mr-10px">Sign In</span>
                <LoginIcon className={iconClassNames} />
              </div>
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};

TransparentHeader.propTypes = {
  openSidebar: PropTypes.func.isRequired,
  isPrimary: PropTypes.bool,
};

export default TransparentHeader;
